import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

export interface OwnedWorkspace {
  workspace_id: string;
  name: string;
  timezone: string;
  created_at: string;
}

export function useOwnedWorkspaces() {
  return useQuery({
    queryKey: ['workspaces', 'owned'],
    queryFn: () => apiFetch<{ workspaces: OwnedWorkspace[] }>('/api/workspaces'),
    staleTime: 15_000,
  });
}

export function useCreateAccountWorkspace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) =>
      apiFetch<{ workspace_id: string }>('/api/account/workspaces', {
        method: 'POST',
        body: JSON.stringify({ name }),
      }),
    onSuccess: async () => {
      await Promise.all([
        qc.invalidateQueries({ queryKey: ['workspaces'] }),
        qc.invalidateQueries({ queryKey: ['me'] }),
      ]);
    },
  });
}

export function useDeleteAccountWorkspace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (workspace_id: string) =>
      apiFetch(`/api/account/workspaces/${workspace_id}`, { method: 'DELETE' }),
    onSuccess: async () => {
      await Promise.all([
        qc.invalidateQueries({ queryKey: ['workspaces'] }),
        qc.invalidateQueries({ queryKey: ['me'] }),
      ]);
    },
  });
}

// Abre o Stripe Billing Portal (adicionar slots / trocar cartão / cancelar).
export function useBillingPortal() {
  return useMutation({
    mutationFn: () => apiFetch<{ url: string }>('/api/account/portal', { method: 'POST' }),
  });
}
